import styled from 'styled-components';

export const Content = styled.div``;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
`;

export const Title = styled.h4`
  font-size: var(--fs-body);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-body);
  color: var(--text);
`;

export const Text = styled.div`
  font-size: var(--fs-body);
  font-weight: var(--fw-regular);
  line-height: var(--lh-prose);
  color: var(--text-muted);
`;

export const Buttons = styled.div`
  display: flex;
  width: 100%;
  margin-top: var(--s5);
  gap: var(--s3);
  justify-content: center;
`;

/*
 * The design's `.empty-icon` — a soft square, not a saturated 40px disc with
 * a white glyph punched out of it. The old version used `#ff6464` for delete
 * and `--primary-green` for confirm, so the two dialogs read as two different
 * products; both are the semantic soft ground with the semantic ink now.
 */
export const Icon = styled.div`
  width: var(--h-avatar-lg);
  height: var(--h-avatar-lg);
  border-radius: var(--r-md);
  display: grid;
  place-items: center;
  border: 1px solid var(--line);

  &.delete {
    background: var(--danger-soft);
    color: var(--danger);
    border-color: var(--danger-line);
  }

  &.success {
    background: var(--primary-soft);
    color: var(--primary);
  }

  svg {
    width: 18px;
    height: 18px;
    stroke-width: 1.7;
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 84px;
  margin-top: var(--s4);
  padding: var(--s2) var(--s3);
  font-family: var(--font-content);
  font-size: var(--fs-body);
  line-height: 1.5;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--line-strong);
  border-radius: var(--r-sm);
  resize: vertical;
  transition:
    border-color 0.12s,
    box-shadow 0.12s;

  &::placeholder {
    color: var(--text-faint);
  }

  &:hover {
    border-color: var(--text-faint);
  }

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--primary-soft);
  }
`;
